
import { computed, defineComponent, PropType, Ref } from 'vue';
import ProfileInfo from '@/b2c/profile/ui/ProfileInfo.vue';
import ProfilePassword from '@/b2c/profile/ui/ProfilePassword.vue';
import ProfileAddress from '@/b2c/profile/ui/ProfileAddress.vue';
import ProfileDelete from '@/b2c/profile/ui/ProfileDelete.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import profileStore from '@/b2c/profile/profile.store';
import { Country } from '@/types/B2CcontentServerContract';

export default defineComponent({
    name: 'Profile',
    components: { ProfileInfo, ProfilePassword, ProfileAddress, ProfileDelete },
    props: {
        countries: {
            type: Array as PropType<Country[]>,
            required: true,
        },
        confirmEmailSettings: {
            type: String,
            required: true,
        },
    },
    setup() {
        const labels = useBlockLabels();
        const isInformationEditMode: Ref<boolean> = computed(() => profileStore.isInformationEditMode);
        const isPasswordEditMode: Ref<boolean> = computed(() => profileStore.isPasswordEditMode);
        const editModeAnimationKey: Ref<boolean> = computed(() => isInformationEditMode.value || isPasswordEditMode.value);

        profileStore.initProfile();

        return {
            labels,
            editModeAnimationKey,
            isInformationEditMode,
            isPasswordEditMode,
        };
    },
});
